import DictionaryList from './DictionaryList';

export default DictionaryList;
